import React, { useState } from "react";
import { ServicesData } from "../../lib/ProjectDetails";

const ServiceCard = ({ service, index }) => {
  const [expanded, setExpanded] = useState(false);
  const toggleExpand = () => setExpanded(!expanded);

  const shouldTruncate = service.content.length > 150;
  const displayText =
    expanded || !shouldTruncate
      ? service.content
      : service.content.slice(0, 200) + "...";

  return (
    <article className={`card card${index + 1}`} role="listitem">
      <div className="icon">{service.icon}</div>
      <h2 className="title">{service.title}</h2>
      <p className="content">
        {displayText}
        {shouldTruncate && (
          <span
            onClick={toggleExpand}
            className="read-text"
            style={{
              color: "#00c9a7",
              cursor: "pointer",
              marginLeft: "8px",
              fontWeight: "500",
            }}
          >
            {expanded ? "Read Less" : "Read More"}
          </span>
        )}
      </p>
    </article>
  );
};

const ServiceCards = () => {
  return (
    <section className="card-container" aria-labelledby="services-heading">
      <div className="main">
        <header className="desc-container">
          <h1 id="services-heading" className="heading">
            Our Specialized Services
          </h1>
          <p className="description">
            At Porto Consulting, we provide a wide array of specialized services
            tailored to the unique needs of our clients in energy sectors.
          </p>
        </header>

        <div className="cards-section" role="list">
          {ServicesData.map((service, index) => (
            <ServiceCard service={service} index={index} key={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceCards;
